import { units } from '@ui/css';
import { makeSizeTokens } from '@utils/react/selectors';

const footerSize = makeSizeTokens("--footer", {
  height: units.px(80),
  width: "100%"
});
const footer = "_35sf9diad7";
const progressWrapper = "_35sp1yem5gx";
const bulletsWrapper = "_35sbp3ga80";
const actions = "_35sa1bkucov";
const finishButton = "_35sf1b7cht8";

export { actions, bulletsWrapper, finishButton, footer, footerSize, progressWrapper };
import "./_task-footer.style.linaria.module.css";
//# sourceMappingURL=_task-footer.style.js.map
